import BigStatusIcon from "@components/BigStatusIcon/BigStatusIcon"
import CompletedProcessSrc from "@assets/images/CompletedProcessBackground.png"
import PaymentLinkAmountCard from "@components/PaymentLinkAmountCard/PaymentLinkAmountCard"
import PrimaryButton from "@components/PrimaryButton/PrimaryButton"
import { useNavigate } from "react-router"
import {
    Container,
    BackgroundImage,
    StatusIconWrapper,
    TextContainer,
    Title,
    Subtitle,
    CardContainer,
    ButtonContainer,
    ContentWrapper
} from "./PaymentLinkGenerated.styles"
import { useLocation } from "react-router"
import { useTranslation } from "react-i18next"
import { PALE_BLUE } from "@styles/colors"
import { setHeaderColor } from "@lib/telegram"
import { useEffect } from "react"

const PaymentLinkGenerated = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const amount = location.state?.amount
    const link = location.state?.link
    const { t } = useTranslation()

    useEffect(() => {
        setHeaderColor(PALE_BLUE)
    }, [])

    return (
        <Container>
            <BackgroundImage 
                src={CompletedProcessSrc} 
                alt="Completed process background" 
            />
            <ContentWrapper>
                <StatusIconWrapper>
                    <BigStatusIcon styles={{ width: 92, height: 92 }} status="COMPLETED" />
                </StatusIconWrapper>
                <TextContainer>
                    <Title>
                        {t('paymentLink.generated.header')}
                    </Title>
                    <Subtitle>
                        {t('paymentLink.generated.subtitle')}
                    </Subtitle>
                </TextContainer>
                <CardContainer>
                    <PaymentLinkAmountCard
                        amount={amount}
                        link={link}
                    />
                </CardContainer>
            </ContentWrapper>
            
            <ButtonContainer>
                <PrimaryButton
                    onClick={() => navigate('/payment-link')}
                >
                    {t('paymentLink.generated.doneButton')}
                </PrimaryButton>
            </ButtonContainer>
        </Container>
    )
}

export default PaymentLinkGenerated